import React from 'react';
import { Link as v4Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import CheckCircle from '@zg-rentals/multibrand-ui/lib/icons/CheckCircle';

import ListingActivationTerms from 'app/shared/components/ListingActivationTerms';
import ActivationErrorModal from 'app/shared/components/Modal/ActivationErrorModal';

import './style.scss';

const PostActivationModal = ({
    paths, displayEnableApplicationsBtn, includeUpsell, error, onEnableApplications, onGotItClick,
}) => {
    if (error) {
        return (
            <ActivationErrorModal error={error} />
        );
    }

    const messageAppsEnabled = 'Renters on Zillow, Trulia and HotPads can now contact you and submit rental ' +
        'applications directly from your listing.';
    const messageNoApps = 'Your listing will appear on Zillow, Trulia and HotPads in a couple of minutes.';
    const successMessage = displayEnableApplicationsBtn ? messageAppsEnabled : messageNoApps;

    return (
        <div className="PostActivationModal-content">
            {!includeUpsell && (
                <SpacerRow className="PostActivationModal-content-row">
                    <CheckCircle colorType="marketing" size={100} />
                </SpacerRow>
            )}
            <SpacerRow className="PostActivationModal-content-row">
                <Text type="h2">Your listing is activated</Text>
            </SpacerRow>
            <SpacerRow className="PostActivationModal-content-row">
                <Text type="body">{successMessage}</Text>
            </SpacerRow>
            <SpacerRow />
            {!includeUpsell ? (
                <SpacerRow className="PostActivationModal-content-row">
                    <Button
                        full={true}
                        type="primary"
                        onClick={onGotItClick}
                    >
                        OK, got it
                    </Button>
                </SpacerRow>
            ) : (
                <div className="PostActivationModal-content-upsell">
                    <SpacerRow className="PostActivationModal-content-row">
                        <Text type="h3">Save time with online applications!</Text>
                    </SpacerRow>
                    <SpacerRow className="PostActivationModal-content-row">
                        <Text type="body">
                            Finding a great tenant is easier with applications and screening tools all in
                            one place. Use our online application form with background check and credit
                            screening to find a renter quickly!&nbsp;
                            <Link
                                reactRouterLink={v4Link}
                                type="secondary"
                                href={paths.marketingRoutes.screening}
                                target="_blank"
                                escape={true}
                            >
                                Learn more.
                            </Link>
                        </Text>
                    </SpacerRow>
                    <SpacerRow className="PostActivationModal-content-row">
                        <Button
                            full={true}
                            type="primary"
                            onClick={onEnableApplications}
                        >
                            Yes, enable applications
                        </Button>
                    </SpacerRow>
                    <SpacerRow className="PostActivationModal-content-row">
                        <ListingActivationTerms lowlight={true} actionText="By enabling applications" />
                    </SpacerRow>
                </div>
            )}
        </div>
    );
};

PostActivationModal.defaultProps = {
    includeUpsell: false,
    displayEnableApplicationsBtn: false,
    error: null,
};

PostActivationModal.propTypes = {
    includeUpsell: PropTypes.bool,
    displayEnableApplicationsBtn: PropTypes.bool,
    error: PropTypes.object,
    paths: PropTypes.object.isRequired,
    onGotItClick: PropTypes.func.isRequired,
    onEnableApplications: PropTypes.func.isRequired,
};

export { PostActivationModal };
export default PostActivationModal;
